import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from '@mui/material';

import style from './style';
import { supportMail } from '../../../client/OneistoxApiClient';
import PhoneInputField from '../../Layouts/PhoneInput';
import { trackcontactus } from '../../../analytics/analytics';

const WriteUs = () => {
  const classes = style();

  const [error, setError] = useState(false);
  const [thankyou, setThankyou] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formFields, setFormFlieds] = useState({
    name: '',
    email: '',
    mobile: '',
    subject: '',
    workshopName: '',
    description: '',
  });

  const { name, email, mobile, subject, workshopName, description } =
    formFields;

  const handleChange = (e) => {
    const isCheckbox = e.currentTarget.type === 'checkbox';
    setFormFlieds({
      ...formFields,
      [e.currentTarget.name]: isCheckbox
        ? e.currentTarget.checked
        : e.target.value,
    });
  };

  const formSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      await supportMail(formFields);

      trackcontactus('Contact Us Submitted', {
        name: formFields.name,
        email: formFields.email,
        mobile: formFields.mobile,
        subject: formFields.subject,
        workshopName: formFields.workshopName,
        description: formFields.description,
      });

      setThankyou(true);
    } catch (error) {
      console.log(error);

      setError(true);
    }
  };

  return (
    <Container component="section" className={classes.section}>
      <div className={classes.formContainer}>
        <div className={`${classes.formBox} ${thankyou && classes.sent}`}>
          {!thankyou ? (
            <>
              {error && (
                <Typography variant="body1" color="primary" paragraph>
                  Something went wrong please try again
                </Typography>
              )}

              <Typography variant="h4" component="h2">
                Write to us here
              </Typography>
              <form onSubmit={(e) => formSubmit(e)}>
                <div className={classes.formControl}>
                  <TextField
                    className={classes.myTextField}
                    variant="outlined"
                    type="text"
                    name="name"
                    label="Name"
                    onChange={(e) => handleChange(e)}
                    value={name}
                    id="name"
                    placeholder="Enter Name"
                    required
                  />
                </div>
                <div className={classes.formControl}>
                  <TextField
                    className={classes.myTextField}
                    variant="outlined"
                    type="email"
                    name="email"
                    label="E-mail"
                    onChange={(e) => handleChange(e)}
                    value={email}
                    id="email"
                    placeholder="Enter mail"
                    required
                  />
                </div>
                <div className={classes.formControl}>
                  <Box sx={{ mt: 2, mb: 1 }}>
                    <PhoneInputField
                      value={mobile}
                      setInputValue={setFormFlieds}
                      oldValue={formFields}
                    />
                  </Box>

                  {/* <TextField
                    className={classes.myTextField}
                    variant="outlined"
                    type="tel"
                    name="mobile"
                    label="Mobile No."
                    id="mobile"
                    onChange={(e) => handleChange(e)}
                    value={mobile}
                    placeholder="Enter phone"
                  /> */}
                </div>
                <div className={classes.formControl}>
                  <TextField
                    className={classes.myTextField}
                    id="subject"
                    select
                    name="subject"
                    onChange={(e) => handleChange(e)}
                    value={subject}
                    variant="outlined"
                    required
                    SelectProps={{
                      native: true,
                    }}
                    helperText="Please select the type of your query"
                  >
                    <option value="">Select</option>
                    <option value="Workshops Query">Courses Query</option>
                    <option value="Registration">Registration</option>
                    <option value="Payments">Payments</option>
                    <option value="Other">Other</option>
                  </TextField>
                </div>
                {subject == 'Workshops Query' && (
                  <div className={classes.formControl}>
                    <TextField
                      className={classes.myTextField}
                      variant="outlined"
                      type="text"
                      id="workshopName"
                      name="workshopName"
                      label="Workshop Name "
                      onChange={(e) => handleChange(e)}
                      value={workshopName}
                      placeholder="Enter related courses name"
                      required
                    />
                  </div>
                )}
                <div className={classes.formControl}>
                  <TextField
                    className={classes.myTextField}
                    multiline
                    variant="outlined"
                    type="text"
                    name="description"
                    id="description"
                    onChange={(e) => handleChange(e)}
                    value={description}
                    rows="5"
                    placeholder="Type something…"
                    required
                  />
                </div>

                <div style={{ textAlign: 'center' }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    className={` ${classes.submitBtn}`}
                  >
                    {thankyou ? 'submited' : 'Submit'}
                  </Button>
                  {loading && (
                    <CircularProgress size={24} className={classes.loader} />
                  )}
                </div>
              </form>
            </>
          ) : (
            <Box>
              <Typography variant="h4" component="h2" paragraph>
                Thank you for getting in touch!
              </Typography>
              <Box mt={5} />
              <Typography variant="body1" paragraph>
                We have received your message and would like to thank you for
                writing to us. If your inquiry is urgent, please use the
                telephone number listed below to talk to one of our staff
                members.
              </Typography>
              <Typography variant="body1" paragraph>
                Otherwise, we will reply by email as soon as possible.
              </Typography>
            </Box>
          )}
        </div>
        <div className={classes.infoText}>
          <Typography variant="body1">
            *We usually reply within 48 hours! Make sure you write clearly what
            you would require assistance with {':)'}
          </Typography>
        </div>
      </div>
    </Container>
  );
};

export default WriteUs;
